import HSBB3 from './hsbb-sdk-v3';
import { getToken } from './utility';

const baseURL = process.env.REACT_APP_API_URL_V2;

const HSBBClientV3 = new HSBB3({ baseURL, getToken });

export default HSBBClientV3;
